<template>
  <div class="horizon-container">
    <div id="moveLeft" class="h-100 flex-column bg-ff" style="width: 200px">
      <div class="left-top">
        <div class="flex-1 font-16-30313a">定额分类</div>
      </div>
      <div class="flex-1 h-0" v-if="classifyList && classifyList.length">
        <cate-menu :not-operate="true" :menu-data="classifyList" @on-choose="onChooseMenu" :choose-id="chooseMenuId"></cate-menu>
      </div>
    </div>
    <move-horizon></move-horizon>
    <div class="flex-1 w-0 h-100 flex-column ptb-10 pr-20">
      <div class="flex content-top mb-10">
        <div class="flex-1 bg-ff h-100 flex align-center pl-5 mr-10">
          <div class="tab-item active">
            <span class="bg-4-f5971d"></span>
            {{currentClassify.name}}
          </div>
        </div>
        <div class="flex ml-10">
          <div class="flex align-center bg-ff h-30 border-e2 border-ra mr-10 search">
            <img src="/static/images/sousuo.png" class="icon-14 ml-10 mr-5" alt="">
            <el-input class="border-none" type="text" placeholder="材料名称/编码/规格/型号" v-model="keywords" clearable @keyup.enter.native="onSearch"></el-input>
          </div>
          <button class="btn-30-bg-82b925" @click="onSearch">搜索</button>
        </div>
      </div>
      <div class="flex-1 h-0 flex-column">
        <div class="flex-1 h-0">
          <erp-table ref="erpTable" :table-footer="tableFooter" @change-current-row="changeCurrentRow" :table-data="tableData" :loading="loading" :column-data="columnData"></erp-table>
        </div>
        <Pagination :pageSize="pageSize" v-model="pageNo" :pageTotal="pageTotal" :total="total" @on-jump="jump"></Pagination>
      </div>
      <move-vertical :max="560" :min="220" class="mtb-5" moveDom="bottom"></move-vertical>
      <div id="moveTop" class="flex-column" style="height: 220px">
        <div class="flex align-center">
          <div class="flex align-center mr-20 cursor pb-5 relative" :class="{'tabActive': index === smallTabIndex}" v-for="(item, index) in smallTab" v-if="index === 1" :key="index" @click="switchSmallTab(index)">
            <div class="mr-5" :class="index === smallTabIndex ? 'decoration-line' : 'decoration-line-hui'"></div>
            <div class="font-bold" :class="index === smallTabIndex ? 'font-16-f5971d' : 'font-16-30313a'">{{item}}</div>
          </div>
        </div>
        <div class="hr mb-10"></div>
        <div class="overflow-y flex-1">
          <div class="text-left h-100" v-if="smallTabIndex === 0">
            <el-row :gutter="40">
              <el-col :span="6" class="info-item">
                <div>定额编码：{{currentRow.name}}</div>
              </el-col>
              <el-col :span="12" class="info-item">
                <div>工作内容：{{currentRow.code}}</div>
              </el-col>
              <el-col :span="6" class="info-item">
                <div>单位：{{currentRow.category}}</div>
              </el-col>
              <el-col :span="6" class="info-item">
                <div>客户价：{{currentRow.customerPrice}}</div>
              </el-col>
              <el-col :span="6" class="info-item">
                <div>成本价：{{currentRow.costPrice}}</div>
              </el-col>
              <el-col :span="6" class="info-item">
                <div>分包价：{{currentRow.standard}}</div>
              </el-col>
            </el-row>
          </div>
          <div class="text-left font-12-30313a h-100" v-if="smallTabIndex === 1">
            <div>{{currentRow.workmanship || '暂无说明！'}}</div>
          </div>
          <div class="h-100" v-if="smallTabIndex === 2">
            <erp-table class="grayTable" ref="erpTable2" :table-data="quotaQuantities" :column-data="quantityColumn"></erp-table>
          </div>
          <div class="text-left flex h-100" v-if="smallTabIndex === 3">
            <div v-for="(item, index) in photoList" :key="index" class="mr-10">
              <el-image style="width: 90px; height: 90px" :src="item.completePath" :preview-src-list="srcList" fit="cover"></el-image>
              <div class="font-12-30313a text-center">{{item.name}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from '../../components/Pagination'
import MoveHorizon from '../../components/MoveHorizon'
import MoveVertical from '../../components/MoveVertical'
import CateMenu from '../../components/CateMenu'
import ErpTable from '../../components/ErpTable'
export default {
  name: 'quotaSearch',
  components: {Pagination, MoveHorizon, CateMenu, ErpTable, MoveVertical},
  data () {
    return {
      keywords: '',
      page: 1,
      limit: 20,
      pageSize: 0,
      pageNo: 0,
      pageTotal: 0,
      total: 0,
      classifyList: [],
      tableFooter: [
        {
          columns: ['customerPrice'],
          type: 'sum',
          name: '合计'
        }
      ],
      columnData: [
        {
        //   field: 'specialItem',
        //   title: '特项',
        //   width: '55'
        // }, {
        //   field: 'code',
        //   title: '定额编码',
        //   width: '100'
        // }, {
          field: 'name',
          title: '工作内容',
          minWidth: '100'
        }, {
          field: 'unit',
          title: '单位',
          width: '100'
        }, {
        //   field: 'costPrice',
        //   title: '成本价',
        //   minWidth: '120'
        // }, {
          field: 'customerPrice',
          title: '客户价',
          width: '100'
        // }, {
        //   field: 'subcontractPrice',
        //   title: '分包价',
        //   width: '150'
        // }, {
        //   field: 'grossProfitRate',
        //   title: '毛利率',
        //   width: '150'
        // }, {
        //   field: 'artificialCustomerPrice',
        //   title: '人工客户价',
        //   width: '150'
        // }, {
        //   field: 'auxiliaryCustomerPrice',
        //   title: '辅料客户价',
        //   width: '150'
        // }, {
        //   field: 'mechanicsCustomerPrice',
        //   title: '机械客户价',
        //   width: '150'
        // }, {
        //   field: 'otherCustomerPrice',
        //   title: '其它客户价',
        //   width: '150'
        // }, {
        //   field: 'artificialCostPrice',
        //   title: '人工成本价',
        //   width: '150'
        // }, {
        //   field: 'auxiliaryCostPrice',
        //   title: '辅料成本价',
        //   width: '150'
        // }, {
        //   field: 'mechanicsCostPrice',
        //   title: '机械成本价',
        //   width: '150'
        // }, {
        //   field: 'otherCostPrice',
        //   title: '其它成本价',
        //   width: '150'
        }
      ],
      chooseMenuId: 0,
      currentClassify: {},
      isClassifyShow: true,
      loading: false,
      tableData: [],
      srcList: [],
      smallTab: ['项目内容', '工艺说明', '定额用量', '定额图片'],
      smallTabIndex: 1,
      isErcodeShow: false,
      currentRow: {},
      quotaQuantities: [],
      photoList: [],
      quantityColumn: [
        {
          field: 'type',
          title: '人材机',
          width: '80',
          formatter: 'toQuotaType'
        }, {
          field: 'specialItem',
          title: '特项',
          width: '55'
        }, {
          field: 'name',
          title: '材料名称',
          minWidth: '200'
        }, {
          field: 'unit',
          title: '单位',
          width: '200'
        }, {
          field: 'quantity',
          title: '数量',
          width: '50'
        }, {
          field: 'customerPrice',
          title: '客户单价',
          width: '200'
        }, {
          field: 'costPrice',
          title: '客户合价',
          minWidth: '100'
        }
      ]
    }
  },
  created () {
    this.getClassify()
  },
  mounted () {},
  methods: {
    getQuotaQuantities () {
      this.axios.post('quotaQuantities/list', {quotaId: this.currentRow.id}).then(res => {
        if (res.data.success) {
          this.quotaQuantities = res.data.data
        }
      })
      this.srcList = []
      this.axios.post('quotaPhoto/list', {quotaId: this.currentRow.id}).then(res => {
        if (res.data.success) {
          this.photoList = res.data.data
          for (let i = 0; i < this.photoList.length; i++) {
            this.srcList.push(this.photoList[i].completePath)
          }
        }
      })
    },
    onSearch () {
      this.page = 1
      this.isClassifyShow = false
      this.getClassify()
      this.getMaterial()
    },
    jump (page) {
      this.page = page
      this.getMaterial()
    },
    onChooseMenu (menu) {
      if (this.chooseMenuId !== menu.id) {
        this.chooseMenuId = menu.id
        this.currentClassify = menu
        this.page = 1
        this.keywords = ''
        this.isClassifyShow = true
        this.getMaterial()
      }
    },
    getMaterial () {
      this.tableData = []
      let params = {
        page: this.page,
        limit: this.limit,
        keywords: this.keywords,
        companyId: this.$store.state.companyId
      }
      if (this.isClassifyShow) {
        params.classifyId = this.chooseMenuId
      }
      this.axios.post(`quota/queryForPage`, params).then(res => {
        if (res.data.success) {
          this.tableData = res.data.data.list
          if (this.tableData.length > 0) {
            this.currentRow = this.tableData[0]
            this.getQuotaQuantities()
            // this.srcList = []
            // for (let i = 0; i < this.currentRow.quotaPhotoList.length; i++) {
            //   this.srcList.push(this.currentRow.quotaPhotoList[i].path)
            // }
          }
          this.pageSize = res.data.data.pages
          this.pageNo = this.page
          this.pageTotal = res.data.data.size
          this.total = res.data.data.total
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    getClassify () {
      this.classifyList = []
      this.axios.post(`quotaClassify/findAllClassify`, {companyId: this.$store.state.companyId}).then(res => {
        if (res.data.success) {
          this.classifyList = res.data.data
          this.getDefaultId(this.classifyList)
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    getDefaultId (list) {
      if (list && list.length) {
        let classify = list[0]
        // if (classify.children && classify.children.length) {
        //   this.getDefaultId(classify.children)
        // } else {
        this.chooseMenuId = classify.id
        this.currentClassify = classify
        this.getMaterial()
        // }
      }
    },
    changeCurrentRow (row) {
      this.currentRow = row
      this.quotaQuantities = []
      this.getQuotaQuantities()
    },
    switchSmallTab (index) {
      this.smallTabIndex = index
    },
    toBigImg () {
      this.isErcodeShow = true
    }
  },
  watch: {
    keywords (val) {
      if (val === '') {
        this.getMaterial()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .left-top {
    display: flex;
    align-items: center;
    padding: 0 10px 0 20px;
    border-bottom: 1px solid #e2e2e2;
    height: 40px;
    text-align: left;
    cursor: pointer;
  }
  .decoration-line{
    width: 4px;
    height: 16px;
    background-color: #f5971d;
    border-radius: 4px;
  }
  .decoration-line-hui{
    width: 4px;
    height: 16px;
    background-color: #e2e2e2;
    border-radius: 4px;
  }
  .content-top {
    height: 30px;
    .tab-item {
      font-size: 16px;
      color: #272727;
      display: flex;
      align-items: center;
      margin-right: 15px;
      cursor: pointer;
      span {
        height: 16px;
      }
      &.active {
        color: #f5971d;
      }
    }
  }
  .el-icon-zoom-in {
    position: absolute;
    bottom: 10px;
    right: 10px;
    font-size: 14px;
    color: #30313a;
  }
  .font-13-f5971d {
    font-size: 13px;
    color: #f5971d;
  }
  .el-card {
    height: 90px;
    border: 1px solid #e2e2e2;
    cursor: pointer;
  }
  .info-item > div{
    border-bottom: 1px solid #e2e2e2;
    display: flex;
    align-items: center;
    margin-top: 10px;
    font-size: 12px;
    color: #30313a;
    line-height: 20px;
    height: 20px;
  }
  .tabActive {
    position: relative;
    &:after {
      position: absolute;
      content: '';
      width: 100%;
      height: 1px;
      background-color: #f5971d;
      left: 0;
      bottom: 0;
    }
  }
  .search {
    overflow: hidden;
  }
  .search /deep/.el-input__inner{
    padding-left: 0;
    border: none;
    outline: none;
  }
</style>



// WEBPACK FOOTER //
// src/pages/quotaSearch/quotaSearch.vue